import ArchivedApplicationsList from './ArchivedApplicationsList';

export default ArchivedApplicationsList;
